import React from 'react';
import { BodyText, BoldBodyText, Button, Grid, ModalWindow, SmallBodyText } from '../../../../ui-toolkit';

interface IAffidavitResultModalProps {
  affidavitGeneratingFailed: boolean;
  onModalClose: () => void;
}

export const AffidavitResultModal: React.FC<IAffidavitResultModalProps> = ({
  affidavitGeneratingFailed,
  onModalClose,
}) => {
  return (
    <Grid>
      <ModalWindow onClose={onModalClose}>
        {affidavitGeneratingFailed ? (
          <>
            <BoldBodyText>Affidavit failed to load</BoldBodyText>
            <SmallBodyText>This page will reload.</SmallBodyText>
          </>
        ) : (
          <>
            <BodyText>Affidavit successfully generated!</BodyText>
          </>
        )}
        <Button intent={'ghost'} onClick={onModalClose}>
          Done
        </Button>
      </ModalWindow>
    </Grid>
  );
};
